import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import ComparativeSearchCard from '@/components/cards/comparative-search-card/comparative-search-card';
import GooruSearchCard from '@/components/cards/gooru-search-card/gooru-search-card';

@Component({
    name: 'comparative-content',
    components: {
        'material-icon': GoogleMaterialIcon,
        'comparative-search-card': ComparativeSearchCard,
        'gooru-search-card': GooruSearchCard,
    },
})

export default class ComparativeContent extends Vue {

    // ----------------------------------------------------------------------------
    // Properties
    @Prop()
    private filterParams: any;

    private isPersonlaizedSearch: boolean = false;

    private selectedGrade: any = null;

    private isInitialPage: any = true;

    private start: number = 0;
    private length: number = 10;

    @Watch('filterParams', {deep: true})
    private onChangeFilter(value: any) {
        this.onLoadContent(value);
    }

    private get googleContent() {
        return this.$store.state.comparativeStore.googleSearch;
    }

    private get bingContent() {
        return this.$store.state.comparativeStore.bingSearch;
    }

    private get activityContents() {
        return this.$store.state.comparativeStore.gooruSearch;
    }

    // --------------------------------------------------------------------------
    // Hooks
    private created() {
        this.$store.dispatch('comparativeStore/getGradeList');
    }

    // ------------------------------------------------------------------------------
    // Methods
    private onLoadContent(params: any) {
        this.isInitialPage = false;
        params.length = this.length;
        params.start = this.start;
        const options = {
            params,
            isScroll : false,
        };
        this.$store.dispatch('comparativeStore/googleSearch', options);
        this.$store.dispatch('comparativeStore/bingSearch', options);
        delete params.start;
        params.start = this.start;
        this.$store.dispatch('comparativeStore/comparativeSearch', params);
    }
}
